import { render, staticRenderFns } from "./ProductsBaseRelatedManager.vue?vue&type=template&id=7c800082&scoped=true"
import script from "./ProductsBaseRelatedManager.vue?vue&type=script&lang=js"
export * from "./ProductsBaseRelatedManager.vue?vue&type=script&lang=js"
import style0 from "./ProductsBaseRelatedManager.vue?vue&type=style&index=0&id=7c800082&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c800082",
  null
  
)

export default component.exports